import clsx from 'clsx'
import { type HTMLMotionProps, motion } from 'motion/react'
import { type ReactElement, ReactNode, type Ref } from 'react'
import styles from './ActionButton.module.css'

export interface ActionButtonProps extends HTMLMotionProps<'button'> {
	icon?: ReactElement
	children?: ReactNode
	ref?: Ref<HTMLButtonElement>
	/** 悬浮提示文字；需要包含状态或数值时，单独传入 aria-label */
	tooltip?: string
}

export default function ActionButton({
	icon,
	children,
	className,
	ref,
	tooltip,
	...props
}: ActionButtonProps) {
	return (
		<motion.button
			ref={ref}
			type="button"
			whileTap={{ scale: 0.95 }}
			className={clsx(styles.root, className)}
			title={tooltip}
			aria-label={tooltip}
			{...props}
			onClick={(e) => {
				e.stopPropagation()
				props.onClick?.(e)
			}}
		>
			{icon}
			{children}
		</motion.button>
	)
}
